import { useState, useCallback } from 'react';

/**
 * Hook for updating a scheduled call (date, duration, notes)
 * @returns {Object} updateScheduledCall function, loading, error, clearError
 */
const useUpdateScheduledCall = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const updateScheduledCall = useCallback(
    async ({ scheduledCallId, scheduledDateTime, duration, notes, meetingType }) => {
      setLoading(true);
      setError(null);

      try {
        const body = {};
        if (scheduledDateTime != null) body.scheduledDateTime = scheduledDateTime;
        if (duration != null) body.duration = parseInt(duration, 10);
        if (notes !== undefined) body.notes = notes;
        if (meetingType !== undefined) body.meetingType = meetingType;

        const response = await fetch(
          `${process.env.REACT_APP_BACKEND_STAGING_URL}/api/scheduled-calls/${scheduledCallId}`,
          {
            method: 'PATCH',
            credentials: 'include',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(body)
          }
        );

        if (!response.ok) {
          const errorData = await response.json();
          throw new Error(errorData.message || 'Error al actualizar la llamada');
        }

        const data = await response.json();
        return data.data;
      } catch (err) {
        setError(err.message);
        throw err;
      } finally {
        setLoading(false);
      }
    },
    []
  );

  const clearError = useCallback(() => setError(null), []);

  return {
    updateScheduledCall,
    loading,
    error,
    clearError
  };
};

export default useUpdateScheduledCall;
